import React, { lazy } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { Routes } from "../common/routing";
import { CompatRoute } from "react-router-dom-v5-compat";

// > Dashboard
const Dashboard = lazy(() =>
  import("../screens/Marketplace/Dashboard/Home/Index")
);
const AppSpaceSelection = lazy(() =>
  import("../screens/Marketplace/Dashboard/App/Selection/AppSpaceSelection")
);
const Inbox = lazy(() =>
  import("../screens/Marketplace/Dashboard/Shared/Inbox/Index")
);

const NotFound = lazy(() => import("../screens/Website/NotFound"));

//User
const AuthContainer = lazy(() => import("../screens/InternalUser/Auth/AuthContainer"));

const ExternalAuthenticationRedirect = lazy(() =>
  import("../screens/InternalUser/ExternalProviders/ExternalAuthenticationRedirect")
);
const EmailActivation = lazy(() =>
  import("../screens/InternalUser/Activation/EmailActivation")
);
const SendEmailActivationLink = lazy(() =>
  import("../screens/InternalUser/Activation/EmailActivationLink")
);
const ProtectedRoute = lazy(() => import("../components/ProtectedRoute"));
const PasswordResetLink = lazy(() =>
  import("../screens/InternalUser/ChangePassword/PasswordResetLink")
);
const ChangePassword = lazy(() =>
  import("../screens/InternalUser/ChangePassword/ChangePassword")
);
const AccountInformation = lazy(() =>
  import("../screens/Marketplace/Licensing/Account/AccountInformation")
);

const NewMemberInvitationAcceptanceForm = lazy(() =>
  import("../screens/Website/Onboarding/Invitation/Acceptance")
);

//User/Organisation
const ContextSetter = lazy(() =>
  import("../screens/InternalUser/Auth/ContextSetter")
);

const PortalRouter = (props) => {
  return (
    <div>
      <Switch>
        <ProtectedRoute
          exact
          path={Routes.Application.Dashboard.Default}
          component={Dashboard}
        />
        <ProtectedRoute
          exact
          path={Routes.Application.Dashboard.Home}
          component={Dashboard}
        />
        {/* Deep links (deep-linking design): slugs in, same Dashboard component;
            it resolves the slugs, sets the context and replays the screen as a
            command. */}
        <ProtectedRoute
          exact
          path={Routes.Application.Dashboard.DeepLink.Context}
          component={Dashboard}
        />
        <ProtectedRoute
          exact
          path={Routes.Application.Dashboard.Apps}
          component={Dashboard}
        />
        <ProtectedRoute
          exact
          path={Routes.Website.Pages.Onboarding.UserInvitationAcceptancePage}
          component={NewMemberInvitationAcceptanceForm}></ProtectedRoute>

        <ProtectedRoute
          exact
          path={Routes.Application.Identity.Organisation.Selection}
          component={ContextSetter}
        />
        <ProtectedRoute
          exact
          path={Routes.Application.Dashboard.AppSpace.Selection}
          component={AppSpaceSelection}
        />
        <Route
          exact
          path={Routes.Application.Identity.RequestPasswordResetLink}
          render={(props) => { return <PasswordResetLink standAlone={true} {...props} /> }}
        />

        {/* User */}
        <Route
          exact
          path={Routes.Application.Identity.Social.ExternalLoginCallbackUrl}
          component={ExternalAuthenticationRedirect}
        />
        <ProtectedRoute
          exact
          path={Routes.Application.Identity.RequestEmailActivationLink}
          component={SendEmailActivationLink}
        />
        <Route
          exact
          path={Routes.Application.Identity.RequestPasswordResetLink}
          component={PasswordResetLink}
        />
        <Route
          exact
          path={Routes.Application.Identity.ChangePassword}
          render={(props) => { return <ChangePassword standAlone={true} {...props} /> }}
        />
        <Route exact path="/email-activation" component={EmailActivation} />
        <Route
          exact
          path="/account-information"
          component={AccountInformation}
        />

        {/* Dashboard */}
        <Route
          exact
          path={Routes.Application.Dashboard.Inbox}
          component={Inbox}
        />

        <CompatRoute
          exact
          path={Routes.Application.Identity.Login}
          component={AuthContainer}
        />
        <ProtectedRoute component={NotFound} />
      </Switch>
    </div>
  );
};

export default withRouter(PortalRouter);
